<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { AppState, SetNotification } from '../../../etc/stores';
  import { replaceVariables } from '../../../i18n';

  const t = (text: string, values?: any) => {
    return replaceVariables($_(`referral.${text}`), values);
  };

  const onClick = () => {
    SetNotification('referredCoin', true);
  };

  const discount = Number(
    $AppState.referralReferredState.businessReferral.referredDiscount
  );
  const referringFirstName =
    $AppState.referralReferredState.referringCustomer.name;
</script>

<p on:click={() => onClick()}>
  {@html t('reminder', { discount: Number(discount), referringFirstName })}
</p>

<style lang="scss">
  @use './styles.scss' as *;
</style>
